import { EN_LOCALES } from './locales';

export const LOCALES = {
  en: EN_LOCALES,
};
